



















































import { Component, Vue } from "vue-property-decorator";
import validate from "@/directives/validate";
import { ExportColumnTitles } from "@/services/users/types";
import { exportUserList } from "@/services/users/usersService";
import i18n from "@/i18n";
import { getAllApplicationSettings } from "@/services/applicationSettings/applicationSettingsService";
import { ApplicationSettings } from "@/services/applicationSettings/types";

@Component({
    directives: { validate }
})
export default class ExportUserListModal extends Vue {
    // Data properties
    isBusy = false;
    error = false;
    disableDaysToAutoDelete = false;

    // Array representing selected export column options
    selectedColumnOptions: ExportColumnTitles[] = [ExportColumnTitles.FullName, ExportColumnTitles.Email];

    // computed

    // Array representing all available export column options
    get columnOptions() {
        return [
            { columnValue: ExportColumnTitles.FullName, columnTitle: i18n.t("users.exportColumn.name"), disabled: true },
            { columnValue: ExportColumnTitles.Email, columnTitle: i18n.t("users.exportColumn.email"), disabled: true },
            { columnValue: ExportColumnTitles.Role, columnTitle: i18n.t("users.exportColumn.role") },
            { columnValue: ExportColumnTitles.CreationDate, columnTitle: i18n.t("users.exportColumn.creationDate") },
            { columnValue: ExportColumnTitles.LastLogin, columnTitle: i18n.t("users.exportColumn.lastLogin") },
            { columnValue: ExportColumnTitles.autoDelete, columnTitle: this.disableDaysToAutoDelete ? i18n.t("users.exportColumn.daysToAutoDelete") + " (N/A)" : i18n.t("users.exportColumn.daysToAutoDelete"), disabled: this.disableDaysToAutoDelete },
            { columnValue: ExportColumnTitles.UserGroups, columnTitle: i18n.t("users.exportColumn.userGroups") },
            { columnValue: ExportColumnTitles.Channels, columnTitle: i18n.t("users.exportColumn.channels") },
            { columnValue: ExportColumnTitles.FolderAccess, columnTitle: i18n.t("users.exportColumn.folder") },
            { columnValue: ExportColumnTitles.Solutions, columnTitle: i18n.t("users.exportColumn.solutions") },
            { columnValue: ExportColumnTitles.Templates, columnTitle: i18n.t("users.exportColumn.templates") }
        ];
    }

    // mounted

    mounted() {
        // checking application settings's clearUserData value to disable or enable daysToAutoDelete checkbox.
        getAllApplicationSettings().then((applicationSettings: ApplicationSettings) => {
            this.disableDaysToAutoDelete = !applicationSettings.clearUserData;
        });
    }

    // Methods
    open() {
        this.$bvModal.show("modal-ExportUserList");
    }

    close() {
        this.$bvModal.hide("modal-ExportUserList");
        this.isBusy = false;
        this.error = false;
    }

    selectAllColumns() {
        this.selectedColumnOptions = [ExportColumnTitles.FullName, ExportColumnTitles.Email];
        for (const columnOption of this.columnOptions) {
            if (!columnOption.disabled) {
                this.selectedColumnOptions.push(columnOption.columnValue);
            }
        }
    }

    clearAllColumns() {
        this.selectedColumnOptions = [ExportColumnTitles.FullName, ExportColumnTitles.Email]; // clear all and only add required columns
    }

    goToSupportPage() {
        this.$router.push({ path: "/support" });
    }

    downloadUserList() {
        this.isBusy = true;
        exportUserList(this.selectedColumnOptions).then(() => {
            this.isBusy = false;
            this.close();
        }).catch(() => {
            this.isBusy = false;
            this.error = true;
        });
    }
}
